import React, { useEffect } from "react";
import {useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useTheme} from "@/comn/hooks";
import {Button, Grid, Group, Layout, Page} from "@/comn/components";
import {APIS, SF_CSTMSROLE_SRCH, SG_SCRH_ROLE_LIST} from "./services/PtliCstmRoleService";
import { comnUtils } from "@/comn/utils";

/*
 * Customs Role Connection Target Inquiry Pop-up Screen
 * !== 세관 역할 연결대상 조회 팝업 화면 ==!
 */
export const PTLI1006002Q = (props:any): JSX.Element => {
    const { condData, callback, cstmRoleList} = props;
    const { pgeUid } = usePage( {pgeUid: "ptli1006002q"} );
    const modal    = useModal();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const { theme } = useTheme();

    useResource({ defaultSchema: [ { area: "comnCd", comnCd: "COM0024" }, { area: "comnCd", comnCd: "COM0052" } ] });

    const form = {
        roleSrch: useForm({
            defaultSchema: SF_CSTMSROLE_SRCH,
            defaultValues: {...pgeStore?.form} || {}
        })
    };

    const grid = {
        srchRoleList: useGrid({
            defaultSchema: SG_SCRH_ROLE_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        })
    };

    const fetch = {
        getSrchRoleList: useFetch({
            api       : (page = grid.srchRoleList.page, size = grid.srchRoleList.size) => APIS.getSrchRoleList(form.roleSrch.getValues(), page, size),
            enabled   : !comnUtils.isEmpty(form.roleSrch.getValue("cstmOrgzId")),
            key       : [grid.srchRoleList.page, grid.srchRoleList.size],
            onSuccess : () => {

                setStore(pgeUid, {
                    form: form.roleSrch.getValues(),
                    page: grid.srchRoleList.page,
                    size: grid.srchRoleList.size,
                });
            },
            onError  : () => modal.openModal({content: "msg.com.00025"}) // Failed to select. !== 조회가 실패하였습니다. ==!
        })
    };

    const render = {
        checkbox: (row:any) => row.isRgsrYn !== "Y" && cstmRoleList.findIndex((item:any) => item.roleId === row.roleId)  === -1
    }

    const handler = {
        onApplyClick: () => {
            if(grid.srchRoleList.getChecked().length === 0) {
                modal.openModal({content: "msg.com.00086"}) // No data has been selected.. !== 선택된 데이터가 없습니다. ==!
                return;
            }
            if(callback) callback(grid.srchRoleList.getChecked());
        },
        onSrchClick: () => fetch.getSrchRoleList.fetch()
    };

    useEffect(() => {
        form.roleSrch.setValue("cstmOrgzId", condData.cstmOrgzId);
    }, [theme]);

    return (
        <Page pgeUid={pgeUid} info={true}>
            <Layout direction={"col"}>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.roleSrch.schema.roleId}/>
                                <Group.Control {...form.roleSrch.schema.roleNm}/>
                            </Group.Row>
                        </Group.Section>
                        <Layout.Right><Button role={"search"} onClick={handler.onSrchClick}/></Layout.Right>
                    </Group.Body>
                </Group>

                <Layout direction={"row"}>

                    <Group>
                        <Group.Body>
                            <Grid
                                {...grid.srchRoleList.grid}
                                data={fetch.getSrchRoleList.data?.roleList}
                                render={render}
                            />
                            <Layout.Right> <Button role={"apply"} onClick={handler.onApplyClick}/> </Layout.Right>
                        </Group.Body>
                    </Group>

                </Layout>
            </Layout>
        </Page>
    );
};
